import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=1f7797f6&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7797f6')) {
      api.createRecord('1f7797f6', component.options)
    } else {
      api.reload('1f7797f6', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=1f7797f6&", function () {
      api.rerender('1f7797f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/Tabs/Tab.vue"
export default component.exports